module.exports = __webpack_public_path__ + "static/tirto-polri-3fbca14abf0b7bfd4863de666923c038.jpg";